export default __webpack_public_path__ + "static/media/bossylion-logo.9ad648d7.png";